<template>
  <router-view />
</template>

<script>
export default {
  mounted () {
    console.log('deposit View');
  },
}
</script>

<style scoped>

</style>
